import { Component, OnInit, Injector } from '@angular/core';
import { FilterableService } from '../../../filterable-service';
import { AuthenticationService } from '../../../../../auth.service';
import { UntypedFormBuilder } from '@angular/forms';
import {
  ProgramDetailsGAService,
  ProgramDetailsBodyService,
  PlantService,
  AuthorizationService,
  DeliverablesService,
  ArchitectureService,
  GateService,
  SmtService,
  ToolingOperatorService,
  WorkOrderService
} from '../../../ve.service';


const ACTIVE_ONLY_REQUEST = '?activeOnly=true';

@Component({
  selector: 'work-order-search-form',
  templateUrl: './work-order-search-form.component.html',
  styleUrls: ['./work-order-search-form.component.scss',
    '../../work-orders.component.scss']
})
export class WorkOrderSearchFormComponent implements OnInit {
  editForm: any;
  formBuilder: UntypedFormBuilder;
  gaProgramDetailsService: ProgramDetailsGAService;
  bodyProgramDetailsService: ProgramDetailsBodyService;
  plantService: PlantService;
  deliverablesService: DeliverablesService;
  authService: AuthenticationService;
  authzService: AuthorizationService;
  gateService: GateService;
  architectureService: ArchitectureService;
  smtService: SmtService;
  toolingOperatorService: ToolingOperatorService;
  workOrderService: WorkOrderService;
  gateList = new FilterableService();
  architectureList = new FilterableService();
  allSMTs = new FilterableService();
  smt1List = new FilterableService();
  smt2List = new FilterableService();
  smt3List = new FilterableService();
  programsList = new FilterableService();
  plantsList = new FilterableService();
  deliverablesList = new FilterableService();
  usersList = new FilterableService();
  statusList = new FilterableService();
  toolingOperatorList = new FilterableService();
  defaultSMT1: any;
  defaultSMT2: any;
  defaultSMT3: any;
  architecture: any;
  ergoEngineer: any;
  meLead: any;
  isBodyModule: boolean;
  programDetailsService: any;
  bodyForm = {
    Requestor: [],
    AssignedEngineer: [],
    PlantId: [],
    ProgramId: [],
    DeliverableId: []
  };
  gaForm = {
    ME: [],
    AssignedEngineer: [],
    ErgoEngineer: [],
    ProgramId: [],
    PlantId: [],
    ArchitectureId: [],
    GateId: [],
    StatusId: [],
    SMT1Id: [],
    SMT2Id: [],
    SMT3Id: [],
    ToolingOperatorInterfaceId: []
  };

  constructor(injector: Injector) {
    this.gaProgramDetailsService = injector.get(ProgramDetailsGAService);
    this.bodyProgramDetailsService = injector.get(ProgramDetailsBodyService);
    this.plantService = injector.get(PlantService);
    this.deliverablesService = injector.get(DeliverablesService);
    this.authzService = injector.get(AuthorizationService);
    this.authService = injector.get(AuthenticationService);
    this.gateService = injector.get(GateService);
    this.architectureService = injector.get(ArchitectureService);
    this.smtService = injector.get(SmtService);
    this.workOrderService = injector.get(WorkOrderService);
    this.toolingOperatorService = injector.get(ToolingOperatorService);
    this.isBodyModule = this.authService.getModule() === 'VE_Body';
    this.formBuilder = injector.get(UntypedFormBuilder);
    this.editForm = this.formBuilder.group(this.isBodyModule ? this.bodyForm : this.gaForm);
    this.programDetailsService = this.isBodyModule ? this.bodyProgramDetailsService : this.gaProgramDetailsService;
  }

  ngOnInit() {
    if (this.isBodyModule) {
      Promise.all([
        this.getPrograms(),
        this.getPlants(),
        this.getContacts(),
        this.getDeliverables(),
      ]);
    } else {
      Promise.all([
        this.getContacts(),
        this.getPrograms(),
        this.getPlants(),
        this.getGates(),
        this.getArchitecture(),
        this.getGates(),
        this.getStatuses(),
        this.getSMT1s(),
        this.getToolingOperatorInterfaces()
      ]);
    }
  }

  getContacts(): Promise<any> {
    const userModule = this.isBodyModule ? 'VE_Body' : 'VE_GA';
    return this.authzService.read('/moduleusers?moduleName=' + userModule)
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.Name.localeCompare(b.Name));
          this.usersList.next(response); 
        }
      });
  }

  getPrograms(): Promise<any> {
    return this.programDetailsService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.ProgramCode.localeCompare(b.ProgramCode));
          this.programsList.next(response);
        }
      });
  }

  getPlants(): Promise<any> {
    return this.plantService.read()
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.PlantDescription.localeCompare(b.PlantDescription));
          this.plantsList.next(response);
        }
      });
  }

  getDeliverables(): Promise<any> {
    return this.deliverablesService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.Description.localeCompare(b.Description));
          this.deliverablesList.next(response);
        }
      });
  }

  getArchitecture(): Promise<any> {
    return this.architectureService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.Description.localeCompare(b.Description));
          this.architectureList.next(response);
        }
      });
  }

  getGates(): Promise<any> {
    return this.gateService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        if (response) {
          this.gateList.next(response);
        }
      });
  }

  getStatuses(): Promise<any> {
    return this.workOrderService.read('/GetWorkOrderStatuses')
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.Description.localeCompare(b.Description));
          this.statusList.next(response);
        }
      });
  }

  getToolingOperatorInterfaces(): Promise<any> {
    return this.toolingOperatorService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.Description.localeCompare(b.Description));
          this.toolingOperatorList.next(response);
        }
      });
  }

  getSMT1s(): Promise<any> {
    const smt1s: any[] = [];

    return this.smtService.read(ACTIVE_ONLY_REQUEST)
      .then(response => {
        if (response) {
          response.forEach(smt => {
            if (smt.SMTReferenceId == null) { smt1s.push(smt); }
          });
          smt1s.sort((a, b) => a.Description.localeCompare(b.Description));
          this.smt1List.next(smt1s);
          this.allSMTs.next(response);
        }
      });
  }

  getSMT2s(smtParentId: any[]): Promise<any> {
    return this.smtService.read('/smtchildren/' + smtParentId)
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.Description.localeCompare(b.Description));
          this.smt2List.next(response);
        }
      });
  }

  getSMT3s(smtParentId: any[]): Promise<any> {
    return this.smtService.read('/smtchildren/' + smtParentId)
      .then(response => {
        if (response) {
          response = response.sort((a, b) => a.Description.localeCompare(b.Description));
          this.smt3List.next(response);
        }
      });
  }

  onSMT1Selection(event: any) {
    const smtParentId = event;
    this.editForm.get('SMT2Id').setValue(null);
    this.editForm.get('SMT3Id').setValue(null);

    if (!smtParentId) {
      this.smt2List.next(null);
      this.smt3List.next(null);
    } else {
      this.getSMT2s(smtParentId);
    }
  }

  onSMT2Selection(event: any) {
    const smtParentId = event;
    this.editForm.get('SMT3Id').setValue(null);

    if (!smtParentId) {
      this.smt3List.next(null);
    } else {
      this.getSMT3s(smtParentId);
    }
  }
}
